export const version = "strings/5.2.0";
